import { useEffect, useState } from "react";
import { WP_API_URL } from "@/data/siteContent";

const decode = (html) => {
  const t = document.createElement("textarea");
  t.innerHTML = html;
  return t.value;
};

const strip = (html) => decode((html || "").replace(/<[^>]+>/g, "").trim());

const mapPost = (post) => {
  const html = post.content?.rendered || "";
  const paragraphs = [...html.matchAll(/<p[^>]*>([\s\S]*?)<\/p>/gi)].map((m) =>
    strip(m[1])
  ).filter(Boolean);
  const list = [...html.matchAll(/<li[^>]*>([\s\S]*?)<\/li>/gi)].map((m) =>
    strip(m[1])
  ).filter(Boolean);
  return {
    id: `wp-${post.id}`,
    title: decode(post.title?.rendered || ""),
    text: paragraphs[0] || "",
    list,
    image: post._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "",
  };
};

const caches = {};

export const useWpCollection = (categorySlug, fallbackItems) => {
  const [items, setItems] = useState(fallbackItems);

  useEffect(() => {
    let cancelled = false;
    if (!caches[categorySlug]) {
      caches[categorySlug] = (async () => {
        const cats = await (
          await fetch(`${WP_API_URL}/categories?slug=${categorySlug}`)
        ).json();
        if (!Array.isArray(cats) || cats.length === 0) return null;
        const posts = await (
          await fetch(
            `${WP_API_URL}/posts?categories=${cats[0].id}&_embed=1&per_page=100&orderby=date&order=asc`
          )
        ).json();
        if (!Array.isArray(posts) || posts.length === 0) return null;
        return posts.map(mapPost);
      })().catch(() => null);
    }
    caches[categorySlug].then((data) => {
      if (!cancelled && data && data.length) setItems(data);
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categorySlug]);

  return items;
};
